import { useTranslation } from 'react-i18next';
import { TenantReadModel, useGetAgreementsStakeholdersQuery } from '@client/api';
import { SelectionModal } from '../selection-modal/selection-modal';

export type LegalPersonsAddModalProps = {
  onChange: (legalPersons: TenantReadModel[]) => void;
  selected?: TenantReadModel[];
  open?: boolean;
  onClose?: () => void;
  disabledIds?: string[];
  maxSelectedItems?: number;
  maxSelectedItemsMessage?: string;
};

export const LegalPersonsAddModal = ({ onChange, selected, open, onClose, disabledIds, maxSelectedItems, maxSelectedItemsMessage }: LegalPersonsAddModalProps) => {
  const { t } = useTranslation('agreements');
  return (
    <SelectionModal<TenantReadModel>
      open={open}
      selected={selected}
      onClose={onClose ?? (() => {})}
      onSubmit={onChange}
      title={t('selectLegalPersons')}
      searchQuery={useGetAgreementsStakeholdersQuery}
      getItemName={(legalPerson) => legalPerson.name ?? ''}
      entityName="entity.legalPerson"
      disabledIds={disabledIds}
      maxSelectedItems={maxSelectedItems}
      maxSelectedItemsMessage={maxSelectedItemsMessage}
    />
  );
};
